import { Spin } from 'antd'
import styled, { keyframes } from 'styled-components'

const SpinnerExpandKeyframes = keyframes`
  0% {
    font-size: 5rem;
  }

  50% {
    font-size: 15rem;
  }

  100% {
    font-size: 5rem;
  }
`

const SpinnerExpandKeyframesSmall = keyframes`
  0% {
    font-size: 3rem;
  }

  50% {
    font-size: 6rem;
  }

  100% {
    font-size: 3rem;
  }
`

const SpinnerRotateKeyframes = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`

export const ScreenSpin = styled(Spin).attrs(() => ({ size: 'large' }))`
  margin: auto;

  & .ant-spin-dot {
    animation:
      1.5s ${SpinnerExpandKeyframes} infinite linear,
      2s ${SpinnerRotateKeyframes} infinite linear;
  }

  & .ant-spin-dot-item {
    width: 4rem !important;
    height: 4rem !important;
  }
`

export const SmallScreenSpin = styled(Spin).attrs(() => ({ size: 'large' }))`
  margin: auto;

  & .ant-spin-dot {
    animation:
      1.5s ${SpinnerExpandKeyframesSmall} infinite linear,
      2s ${SpinnerRotateKeyframes} infinite linear;
  }

  & .ant-spin-dot-item {
    width: 2rem !important;
    height: 2rem !important;
  }
`
